import { Dialog } from '@ark-ui/react';
import { type ReactNode } from 'react';
import { Portal } from '../Portal';
import { Icon } from '../Icon/Icon';
import styles from './Drawer.module.scss';

export interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** Optional heading shown at the top of the panel */
  title?: string;
  /** Which edge the panel slides in from (default: 'left') */
  side?: 'left' | 'right';
  /** Optional data-theme override applied to the panel (e.g. 'dark') */
  dataTheme?: string;
  'data-testid': string;
}

export const Drawer = ({
  open,
  onClose,
  children,
  title,
  side = 'left',
  dataTheme,
  'data-testid': dataTestid,
}: DrawerProps) => {
  if (!open) return null;

  return (
    <Dialog.Root
      open
      onOpenChange={({ open: isOpen }) => {
        if (!isOpen) onClose();
      }}
      closeOnInteractOutside
      closeOnEscape
    >
      <Portal>
        <Dialog.Backdrop className={styles['backdrop']} />
        <Dialog.Positioner className={styles['positioner']}>
          <Dialog.Content
            className={`${styles['content']} ${styles[`content--${side}`]}`}
            data-testid={dataTestid}
            aria-label={title}
            data-theme={dataTheme}
          >
            <div className={styles['drawer-header']}>
              {title && (
                <Dialog.Title className={styles['drawer-title']}>
                  {title}
                </Dialog.Title>
              )}
              <Dialog.CloseTrigger
                className={styles['close-btn']}
                aria-label="Zavřít"
                data-testid={`${dataTestid}-close`}
              >
                <Icon name="x-mark" size={24} aria-hidden="true" />
              </Dialog.CloseTrigger>
            </div>

            <div className={styles['drawer-body']}>{children}</div>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
